import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";
import { B2bStatsCardProps } from "@/services/organizationsApi";

const chartConfig: ChartConfig = {
  count: { label: "Organisations", color: "hsl(var(--chart-2))" },
};

export function B2bSeatOccupancyBarCard({
  stats,
  loading,
  error,
}: B2bStatsCardProps) {
  const chartData = (stats?.seats.occupancy_histogram ?? []).map((b) => ({
    name: b.label,
    count: b.count,
  }));
  const hasData = chartData.some((d) => d.count > 0);

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">
          Occupation des sièges
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        ) : error ? (
          <div className="text-sm text-red-600">{error}</div>
        ) : !hasData ? (
          <div className="text-sm text-muted-foreground">
            Aucune organisation entreprise
          </div>
        ) : (
          <ChartContainer config={chartConfig} className="max-h-[250px]">
            <BarChart data={chartData}>
              <CartesianGrid vertical={false} />
              <XAxis
                dataKey="name"
                tickLine={false}
                axisLine={false}
                fontSize={11}
              />
              <YAxis tickLine={false} axisLine={false} allowDecimals={false} />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Bar
                dataKey="count"
                fill="var(--color-count)"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}
